import axios from '@axios'

export default {
  namespaced: true,
  state:{
  deviceData:{}
  },

   mutations:{
    SETDEVICEDATA(state,data){
      Object.assign(state,{deviceData:{xx:222}})
    }
   },
  actions: {
    getDeviceInfo(ctx,queryParams){
      return new Promise((resolve,reject) => {
        axios.get('maps/get_devices', { params: queryParams })
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },

    getRoute(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('maps/getRoute', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getRouteLive(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('maps/getRoute', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getEvents(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('maps/getEvents', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getFilterOptionsBy(ctx, q) {
      return new Promise((resolve, reject) => {
        axios.get('filters/getFilterBy', { params: q })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
  }
  },
  
  

}
